import { memo } from "react";
import { Button } from "react-bootstrap";
import EarlyStagePriceChoice from "./EarlyStagePriceChoice";

interface EarlyStagePlanStepProps {
  onBack: () => void;
  onComplete: (monthlyFeeGbp: number) => void;
}

function EarlyStagePlanStepInner({ onBack, onComplete }: EarlyStagePlanStepProps) {
  return (
    <div className="w-100">
      <h5 className="mb-3">Choose your monthly payment</h5>
      <EarlyStagePriceChoice onComplete={onComplete} />
      <div className="d-flex justify-content-start mt-2">
        <Button type="button" variant="outline-secondary" onClick={onBack}>
          Back
        </Button>
      </div>
    </div>
  );
}

export default memo(EarlyStagePlanStepInner);
